module.exports = __webpack_public_path__ + "img/phone_charge.bdb814cd.png";